import { render, staticRenderFns } from "./selectionVoPostsList.vue?vue&type=template&id=3a18eea0&scoped=true&"
import script from "./selectionVoPostsList.vue?vue&type=script&lang=js&"
export * from "./selectionVoPostsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18eea0",
  null
  
)

export default component.exports